import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttperrorhandlerService } from 'src/app/main/shared/http/httperrorhandler.service';
import { environment } from 'src/environments/environment';
import { IndiaStateCodes } from './nhip-home-map/nhip-home-map-constants';

@Injectable({
  providedIn: 'root'
})
export class NhipHomeDataService {

  constructor(private http: HttpClient, private errorHandler: HttperrorhandlerService) { }

  getLocationList(postData) {
    return this.http.post<any>(environment.url.HEATWAVE_STAGING_API_URL + "rf/aggregated", postData).pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }
  getHazardData(postData) {
    return this.http.post<any>(environment.url.OBSERVED_API_URL + "nhip/getNHIPHazardData", postData).pipe(
      catchError(this.errorHandler.handleError('Hazard data request', []))
    );
  }
  getEffectedCount(postData) {
    return this.http.post<any>(environment.url.OBSERVED_API_URL + "nhip/getLocWiseHazardDataCount", postData).pipe(
      catchError(this.errorHandler.handleError('Hazard data request', []))
    );
  }
  getEarthquakeHazardData(postData) {
    return this.http.post<any>(
      environment.url.OBSERVED_API_URL + 'nhip/getEarthquakeHazardData',
      postData
    ).pipe(
      catchError(this.errorHandler.handleError('Earthquake hazard request', []))
    );
  }
  getCycloneZoneData(postData) {
    return this.http.post<any>(
      environment.url.OBSERVED_API_URL + 'nhip/getLocWiseWindZonePercentage',
      postData
    ).pipe(
      catchError(this.errorHandler.handleError('Cyclone zone data request', []))
    );
  }
  getDistrictFaultline(postData: any) {
    return this.http.post<any>(
      environment.url.OBSERVED_API_URL + 'nhip/getEarthquakeFaultline',
      postData
    ).pipe(
      catchError(this.errorHandler.handleError('Fault line data request', {
        faultLines: [],
        nearestFaultLine: null,
        faultLineCount: 0,
        districtUuid: ''
      }))
    );
  }
  getStateWindZonePercentage(postData) {
    return this.http.post<any>(
      environment.url.OBSERVED_API_URL + 'nhip/getLocWiseWindZonePercentage',
      postData
    ).pipe(
      catchError(this.errorHandler.handleError('State wind zone data request', []))
    );
  }
  getEarthquakeZonePercentage(postData) {
    return this.http.post<any>(
      environment.url.OBSERVED_API_URL + 'nhip/getLocWiseEqZonePercentage',
      postData
    ).pipe(
      catchError(this.errorHandler.handleError('Earthquake zone data request', []))
    );
  }
  getLocationByPoint(postData: any) {
    return this.http.post<any>(
      environment.url.OBSERVED_API_URL + '/nhip/getLocationByPoint',
      postData
    ).pipe(
      catchError(this.errorHandler.handleError('Location by point request', {
        latitude: null,
        longitude: null,
        Location: null
      }))
    );
  }
  getCycloneGradeWiseData(postData: any) {
    return this.http.post<any>(
      environment.url.OBSERVED_API_URL + '/nhip/getCycloneGradeWiseData',
      postData
    ).pipe(
      catchError(this.errorHandler.handleError('Cyclone grade wise request', []))
    );
  }

  // Initial empty state
  private cycloneStatsSubject = new BehaviorSubject<any>(null);

  // Observable for other components
  cycloneStats$ = this.cycloneStatsSubject.asObservable();


  // Method to update stats
  setCycloneStats(stats: any) {
    this.cycloneStatsSubject.next(stats);
  }

  // Optional: get current value without subscribing
  getCycloneStats() {
    return this.cycloneStatsSubject.value;
  }

  getCategoriesForChart(chartData) {
    let categories = []
    for (let i in chartData) {
      let stateName = IndiaStateCodes[chartData[i]['fullName']]
      categories.push(stateName)
    }
    return categories
  }

  getlineChartData(chartData, chartType, type) {
    let categories = chartType == 'line' ? Object.keys(chartData) : this.getCategoriesForChart(chartData)
    let seriesData = chartType == 'line' ? Object.values(chartData) : chartData
    let color = type == 'cyclone' ? '#8bd3f7' : '#ec6e6e'
    const chartOptions = {
      chart: {
        type: chartType,
        backgroundColor: 'transparent',
        height: 200
      },
      title: {
        text: null
      },
      xAxis: {
        categories: categories,
        labels: {
          style: {
            color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif',
          }
        },
        lineColor: '#888888',
        tickColor: '#888888'
      },
      yAxis: {
        title: {
          text: 'Count',
          style: {
            color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif',
          }
        },
        labels: {
          style: {
            color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif',
          }
        },
        gridLineColor: '#666666'
      },
      legend: {
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'bottom',
        itemMarginTop: 4,
        itemMarginBottom: 4,
        symbolRadius: 0,
        itemStyle: {
          color: '#9aa2a7ff',
          fontFamily: 'poppins, sans-serif',
          fontSize: '12px',
          fontWeight: 'normal'
        },
        enabled: false
      },
      credits: { enabled: false },
      tooltip: {
        formatter: function () {
          return `<b>${this.point.fullName || this.key}</b><br/>${this.y} Events`;
        }
      },
      plotOptions: {
        // line: {
        //   lineWidth: 2,
        //   color: '#1E90FF',
        //   marker: {
        //     enabled: true,
        //     radius: 3
        //   }
        // }
      },
      series: [{
        type: chartType,
        data: seriesData,
        color: color,
      }]
    }
    return chartOptions
  }

}
